import React from 'react'
import { IconNameType, IconSizeType } from '../../misc/icon/types'
import Icon from '../../misc/icon'

interface Props {
    className?: string
    disabled?: boolean
    icon: IconNameType
    iconClassName?: string
    onClick?: () => void
    size?: IconSizeType
}

/**
 * Component to allow render an icon button
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @param param0
 * @returns
 */
const IconButton: React.FC<Props> = ({
    className,
    disabled,
    icon,
    iconClassName,
    onClick,
    size
}) => {
    if (disabled) {
        return (
            <span className={`mx-1 ${className} no-underline  opacity-40`}>
                <Icon className={iconClassName} type={icon} size={size} />
            </span>
        )
    }
    return (
        <a className={`mx-1 ${className} no-underline`} onClick={onClick} type="button">
            <Icon className={iconClassName} type={icon} size={size} />
        </a>
    )
}

IconButton.defaultProps = {
    size: 'lg'
}

export default IconButton
